import React from 'react';
import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ClientTable} from 'src/pages/Modules/Clients/shared/ClientTable';
import {SiteTable} from 'src/pages/Modules/Clients/shared/SiteTable';
import {ClientDocumentTitle} from 'src/pages/Modules/Clients/shared/clientHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import type {ClientIndexViewType} from 'src/shared/constants/ViewTypes';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useUrlQueryTabV2} from 'src/shared/hooks/useUrlQueryTabV2';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

export const ClientListPage: React.FC = () => {
  const navigate = useAppNavigate();
  useSetDocumentTitle(ClientDocumentTitle);
  const {view} = useParams();

  const {RenderedTabsComponent} = useUrlQueryTabV2<ClientIndexViewType>({
    view: (view ?? '') as ClientIndexViewType,
    defaultView: 'list',
    tabs: [
      {
        view: 'list',
        label: 'Clients',
        component: <ClientTable />,
      },
      {
        view: 'sites',
        label: 'Sites',
        component: <SiteTable identifier="site-list-page" />,
      },
    ],
    onSelectView: view =>
      navigate(PathUtility.Clients(view as ClientIndexViewType)),
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Clients}>
      {RenderedTabsComponent}
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.Clients(':view'),
  element: <ClientListPage />,
  module: ModuleEnum.Clients,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});
